var map = {
	"./aland-islands.svg": 6989,
	"./albania.svg": 9110,
	"./algeria.svg": 4555,
	"./american-samoa.svg": 5534,
	"./anguilla.svg": 8129,
	"./argentina.svg": 7925,
	"./armenia.svg": 323,
	"./australia.svg": 6260,
	"./austria.svg": 1711,
	"./azerbaijan.svg": 9057,
	"./bahrain.svg": 5917,
	"./belarus.svg": 2794,
	"./belgium.svg": 1681,
	"./bolivia.svg": 2346,
	"./bosnia-and-herzegovina.svg": 6065,
	"./botswana.svg": 2367,
	"./brazil.svg": 6536,
	"./bulgaria.svg": 4873,
	"./cambodia.svg": 3704,
	"./cameroon.svg": 3614,
	"./canada.svg": 252,
	"./chile.svg": 3713,
	"./china.svg": 7643,
	"./colombia.svg": 9588,
	"./costa-rica.svg": 4304,
	"./croatia.svg": 6433,
	"./cuba.svg": 4377,
	"./cyprus.svg": 36,
	"./czech-republic.svg": 768,
	"./denmark.svg": 6188,
	"./ecuador.svg": 3383,
	"./egypt.svg": 8747,
	"./estonia.svg": 7911,
	"./ethiopia.svg": 8091,
	"./finland.svg": 5426,
	"./france.svg": 3295,
	"./georgia.svg": 750,
	"./germany.svg": 3633,
	"./greece.svg": 5107,
	"./haiti.svg": 2345,
	"./hong-kong.svg": 8930,
	"./hungary.svg": 1444,
	"./iceland.svg": 9520,
	"./india.svg": 5287,
	"./indonesia.svg": 3924,
	"./iran.svg": 2502,
	"./iraq.svg": 7857,
	"./ireland.svg": 2915,
	"./israel.svg": 5442,
	"./italy.svg": 5331,
	"./ivory-coast.svg": 4812,
	"./japan.svg": 4302,
	"./kazakhstan.svg": 8912,
	"./kuwait.svg": 8197,
	"./latvia.svg": 8199,
	"./liechtenstein.svg": 6945,
	"./lithuania.svg": 2651,
	"./luxembourg.svg": 6818,
	"./malaysia.svg": 6107,
	"./mexico.svg": 5175,
	"./mongolia.svg": 4612,
	"./montenegro.svg": 2588,
	"./nauru.svg": 1193,
	"./netherlands.svg": 1074,
	"./nicaragua.svg": 6695,
	"./nigeria.svg": 7459,
	"./norway.svg": 4544,
	"./pakistan.svg": 9483,
	"./panama.svg": 5286,
	"./paraguay.svg": 958,
	"./peru.svg": 2692,
	"./philippines.svg": 2003,
	"./portugal.svg": 2704,
	"./puerto-rico.svg": 3291,
	"./republic-of-macedonia.svg": 7556,
	"./republic-of-poland.svg": 8637,
	"./romania.svg": 5843,
	"./russia.svg": 9605,
	"./serbia.svg": 4028,
	"./singapore.svg": 6780,
	"./slovakia.svg": 8730,
	"./slovenia.svg": 5071,
	"./south-africa.svg": 4208,
	"./south-korea.svg": 1424,
	"./spain.svg": 5085,
	"./sri-lanka.svg": 8868,
	"./sweden.svg": 6630,
	"./switzerland.svg": 7769,
	"./taiwan.svg": 8986,
	"./thailand.svg": 2347,
	"./tunisia.svg": 3281,
	"./turkey.svg": 500,
	"./ukraine.svg": 2781,
	"./united-arab-emirates.svg": 6837,
	"./united-kingdom.svg": 7871,
	"./united-states-of-america.svg": 2867,
	"./united-states.svg": 718,
	"./uruguay.svg": 6690,
	"./venezuela.svg": 8555,
	"./vietnam.svg": 558
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 106;